export var ERRORS;
(function (ERRORS) {
    ERRORS["PARAM_NOT_DEFINED"] = "PARAM_NOT_DEFINED";
    ERRORS["INVALID_VALUE"] = "INVALID_VALUE";
    ERRORS["RANGE_ERROR"] = "RANGE_ERROR";
    ERRORS["INVALID_TRADE"] = "INVALID_TRADE";
    ERRORS["PATH_NOT_FOUNDED"] = "PATH_NOT_FOUNDED";
})(ERRORS || (ERRORS = {}));
